import { useEffect, useState } from "react";
import useModal from "../../hooks/useModal";
import ConfirmModal from "../ui/ConfirmModal";
import SuccessModal from "./SuccessModal";
import { DatePicker, Form } from "antd";
import { dbDateFormat } from "../../constants/constants";
import DateIcon from "../../assets/icons/DateIcon";
import dayjs, { Dayjs } from "dayjs";
import { toast } from "../../lib/toast";

type ReportRequestModalType = {
  handleSubmit: (dates: { start_date: string; end_date: string }) => void;
  isLoading?: boolean;
  isSuccess?: boolean;
  open: boolean;
  handleClose: () => void;
};

export default function ReportRequestModalWithMonth({
  handleSubmit,
  isLoading,
  isSuccess,
  ...rest
}: ReportRequestModalType) {
  const { open, handleClose, handleOpen } = useModal<undefined, "SUCCESS">();
  const [month, setMonth] = useState<Dayjs | null>(null);

  const handleOk = () => {
    if (!month) {
      toast("error", "Please select month");
      return;
    }

    handleSubmit({
      start_date: month.startOf("month").format(dbDateFormat),
      end_date: month.endOf("month").format(dbDateFormat),
    });
  };

  useEffect(() => {
    if (isSuccess) {
      handleOpen({ type: "SUCCESS" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      {open?.type === "SUCCESS" && (
        <SuccessModal open={open?.open} handleClose={handleClose} />
      )}

      <ConfirmModal
        handleOk={handleOk}
        title="Confirm Request"
        hideAlert
        okText="Confirm"
        okButtonProps={{
          className: "!rounded !min-w-[110px]",
          loading: isLoading,
        }}
        cancelButtonProps={{
          className: "cancel-btn !min-w-[110px]",
        }}
        width={500}
        {...rest}
      >
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          //   onFinish={onFinish}
          // form={form}
        >
          <Form.Item name="month" label="Select Month" className="mb-1.5">
            <DatePicker
              format="MMMM YYYY"
              suffixIcon={<DateIcon width={18} height={20} />}
              style={{ width: "100%" }}
              size="large"
              picker="month"
              disabledDate={(current) => current && current.isAfter(dayjs())}
              value={month}
              onChange={(val) => setMonth(val)}
            />
          </Form.Item>
          {/* <div className="self-stretch justify-start text-slate-600 text-sm font-normal">
            Are you sure you want to submit this request?
          </div> */}
          <div className="p-4 mt-4 bg-amber-100 rounded text-[#664D03]">
            You can request a report 2 times a day, and total 5 times a month,
            Maximum time range for a Report is 12 months, Processing time may
            take up to 24 hours.
          </div>{" "}
        </Form>
      </ConfirmModal>
    </>
  );
}
